import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import type { ReactNode } from "react";

export default function GeoTooltip({ title }: { title: ReactNode }) {
  return (
    <Tooltip enterTouchDelay={0} title={title}>
      <IconButton>
        <InfoOutlinedIcon />
      </IconButton>
    </Tooltip>
  );
}
